/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RouteLeg } from "./RouteLeg";
import {
  RouteLegFromJSON,
  RouteLegFromJSONTyped,
  RouteLegToJSON,
  RouteLegToJSONTyped,
} from "./RouteLeg";

/**
 *
 * @export
 * @interface CompanyListSavedRoute
 */
export interface CompanyListSavedRoute {
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyListSavedRoute
   */
  orderedCompanyListItemIds: Array<string>;
  /**
   *
   * @type {number}
   * @memberof CompanyListSavedRoute
   */
  startLatitude: number;
  /**
   *
   * @type {number}
   * @memberof CompanyListSavedRoute
   */
  startLongitude: number;
  /**
   *
   * @type {number}
   * @memberof CompanyListSavedRoute
   */
  endLatitude?: number | null;
  /**
   *
   * @type {number}
   * @memberof CompanyListSavedRoute
   */
  endLongitude?: number | null;
  /**
   *
   * @type {Array<RouteLeg>}
   * @memberof CompanyListSavedRoute
   */
  legs?: Array<RouteLeg> | null;
}

/**
 * Check if a given object implements the CompanyListSavedRoute interface.
 */
export function instanceOfCompanyListSavedRoute(
  value: object,
): value is CompanyListSavedRoute {
  if (
    !("orderedCompanyListItemIds" in value) ||
    value["orderedCompanyListItemIds"] === undefined
  )
    return false;
  if (!("startLatitude" in value) || value["startLatitude"] === undefined)
    return false;
  if (!("startLongitude" in value) || value["startLongitude"] === undefined)
    return false;
  return true;
}

export function CompanyListSavedRouteFromJSON(
  json: any,
): CompanyListSavedRoute {
  return CompanyListSavedRouteFromJSONTyped(json, false);
}

export function CompanyListSavedRouteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyListSavedRoute {
  if (json == null) {
    return json;
  }
  return {
    orderedCompanyListItemIds: json["orderedCompanyListItemIds"],
    startLatitude: json["startLatitude"],
    startLongitude: json["startLongitude"],
    endLatitude: json["endLatitude"] == null ? undefined : json["endLatitude"],
    endLongitude:
      json["endLongitude"] == null ? undefined : json["endLongitude"],
    legs:
      json["legs"] == null
        ? undefined
        : (json["legs"] as Array<any>).map(RouteLegFromJSON),
  };
}

export function CompanyListSavedRouteToJSON(json: any): CompanyListSavedRoute {
  return CompanyListSavedRouteToJSONTyped(json, false);
}

export function CompanyListSavedRouteToJSONTyped(
  value?: CompanyListSavedRoute | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    orderedCompanyListItemIds: value["orderedCompanyListItemIds"],
    startLatitude: value["startLatitude"],
    startLongitude: value["startLongitude"],
    endLatitude: value["endLatitude"],
    endLongitude: value["endLongitude"],
    legs:
      value["legs"] == null
        ? undefined
        : (value["legs"] as Array<any>).map(RouteLegToJSON),
  };
}
